import { useSelector } from "react-redux";
import { shopSelectors } from "@hopper-b2b/flights";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Typography } from "@material-ui/core";
import clsx from "clsx";

import "./styles.scss";

export const FlightMobileFareDetailsTripPrice = () => {
  const { formatFiatCurrency } = useI18nContext();

  const tripTotalIncludingOffers = useSelector(
    shopSelectors.tripTotalIncludingOffersSelector
  );

  return (
    <Typography
      className={clsx("uber", "content", "fare-price")}
      variant="body1"
    >
      <span className="total-price">
        {formatFiatCurrency(tripTotalIncludingOffers, {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        })}
      </span>
    </Typography>
  );
};
